module.exports = __webpack_public_path__ + "mcbenik.jpg?f8452a86ee001221b6a842375ddee775";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/mcbenik.jpg
// module id = 679
// module chunks = 0